import React from 'react';
import { Box, themeGet, Text } from '@primer/react';
import { addAriaPropertiesOnBackgroundEls } from '../../utils/functions.js';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import LTButton from '../LTButton/index.js';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["actionType", "text", "type", "className", "onClick", "isCloseButton", "backgroundElementsToHide"];
var _templateObject;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var FooterElementContainer = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  border-top: 1px solid ", ";\n"])), themeGet("colors.border.default"));
var FooterElements = function FooterElements(_ref) {
  var footerElements = _ref.footerElements,
    returnFocusRef = _ref.returnFocusRef;
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    gridGap: "8px"
  }, footerElements === null || footerElements === void 0 ? void 0 : footerElements.map(function (_ref2, index) {
    var actionType = _ref2.actionType,
      text = _ref2.text,
      type = _ref2.type,
      className = _ref2.className,
      _onClick = _ref2.onClick,
      _ref2$isCloseButton = _ref2.isCloseButton,
      isCloseButton = _ref2$isCloseButton === void 0 ? false : _ref2$isCloseButton,
      backgroundElementsToHide = _ref2.backgroundElementsToHide,
      args = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/React.createElement(React.Fragment, null, type === ModalFooter.Type.BUTTON && /*#__PURE__*/React.createElement(LTButton, _extends({
      ariaLabel: text,
      actionType: actionType,
      key: index,
      className: className,
      onClick: function onClick() {
        _onClick();
        // return focus on action button triggering the modal on closing the modal
        if (isCloseButton && returnFocusRef.current) {
          addAriaPropertiesOnBackgroundEls(true, backgroundElementsToHide);
          returnFocusRef.current.focus();
        }
      }
    }, args), text), type === ModalFooter.Type.MESSAGE && /*#__PURE__*/React.createElement(Text, {
      key: index
    }, text));
  }));
};
FooterElements.displayName = "FooterElements";
var ModalFooter = function ModalFooter(_ref3) {
  var rightFooterElements = _ref3.footerElements,
    leftFooterElements = _ref3.leftFooterElements,
    returnFocusRef = _ref3.returnFocusRef,
    _ref3$containerStyle = _ref3.containerStyle,
    containerStyle = _ref3$containerStyle === void 0 ? {} : _ref3$containerStyle;
  return /*#__PURE__*/React.createElement(FooterElementContainer, {
    style: _objectSpread({
      marginTop: "auto"
    }, containerStyle)
  }, /*#__PURE__*/React.createElement(FooterElements, {
    footerElements: leftFooterElements,
    returnFocusRef: returnFocusRef
  }), /*#__PURE__*/React.createElement(FooterElements, {
    footerElements: rightFooterElements,
    returnFocusRef: returnFocusRef
  }));
};
ModalFooter.displayName = "ModalFooter";
ModalFooter.defaultProps = {
  footerElements: [],
  leftFooterElements: [],
  containerStyle: {}
};
ModalFooter.propTypes = {
  footerElements: PropTypes.arrayOf(PropTypes.object),
  leftFooterElements: PropTypes.arrayOf(PropTypes.object)
};
ModalFooter.Type = {
  BUTTON: "button",
  MESSAGE: "message"
};

export { ModalFooter as default };
